import React from 'react';

const logosRow1 = [
  "https://pbs.twimg.com/profile_images/1812420751829422080/QV-SLzAa_200x200.jpg", 
  "https://pbs.twimg.com/profile_images/874276197357596672/kUuht00m_400x400.jpg", 
  "https://pbs.twimg.com/profile_images/1923385112172888065/Elwahdp2_bigger.jpg", 
  "https://pbs.twimg.com/profile_images/1909279867226779648/4qC_yL2-_bigger.jpg",
  "https://pbs.twimg.com/profile_images/1899385457047412736/vfvmbKVj_x96.jpg",
  "https://pbs.twimg.com/profile_images/1909963063618674688/Cct4LuSA_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1732456585652240384/u1-fAC6J_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1798381884340391936/OJcedZiE_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1876179383767236608/Yeek37vI_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1795443155015184384/EeDEvFuQ_400x400.jpg",
];
const logosRow2 = [
  "https://pbs.twimg.com/profile_images/1818978639976779777/gWCocXhV_200x200.jpg", 
  "https://pbs.twimg.com/profile_images/1894912382712893440/H1g0BQZx_400x400.jpg", 
  "https://pbs.twimg.com/profile_images/1896736794810458112/9tsFttK2_200x200.jpg",
  "https://pbs.twimg.com/profile_images/1914503679513608192/uzCeWg5t_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1896838383999315968/9in_yjIS_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1877532281419739137/I_t8rg_V_200x200.jpg", 
  "https://pbs.twimg.com/profile_images/1909591493683429378/ti7DP3xE_x96.jpg",
  "https://pbs.twimg.com/profile_images/1861751545790070784/KvlxTzAq_bigger.jpg",
  "https://pbs.twimg.com/profile_images/1905084157732257792/qIzxjm1A_400x400.jpg",
  "https://pbs.twimg.com/profile_images/1896642719079866369/d0QBYz7D_400x400.jpg",
  // ...你补充
];

const rows = [logosRow1, logosRow2];

const LOGOS_PER_ROW = 10;

function fillToLength(arr: string[], len: number): string[] {
  const result: string[] = [];
  let i = 0;
  while (result.length < len) {
    result.push(arr[i % arr.length]);
    i++;
  }
  return result;
}

function getDisplayLogos(arr: string[]): string[] {
  // 先补齐到10个，再重复一遍用于无缝滚动
  const filled = fillToLength(arr, LOGOS_PER_ROW);
  return [...filled, ...filled];
}

const LogoSection: React.FC = () => (
  <section id="projects" className="py-16 bg-transparent">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <p className="text-gray-400 text-sm uppercase tracking-wide font-medium">
          支持的知名项目
        </p>
      </div>
      <div className="overflow-hidden space-y-8">
        {rows.map((row, i) => (
          <div
            key={i}
            className={`flex items-center gap-8 logo-row animate-row${i+1}`}
            style={{
              minWidth: '100%',
              width: 'max-content',
              marginTop: i === 0 ? 0 : 24,
              animationDelay: `${i * 2}s`
            }}
          >
            {getDisplayLogos(row).map((img, idx) => (
              <div
                key={img + idx}
                className="block w-16 h-16 rounded-xl bg-white/10 shadow flex items-center justify-center transition-transform hover:scale-110"
                style={{ minWidth: 64, minHeight: 64 }}
              >
                <img
                  src={img}
                  alt=""
                  className="w-12 h-12 object-contain rounded-lg"
                  style={{ maxWidth: 48, maxHeight: 48 }}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
    <style>{`
      @keyframes row-scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      .logo-row {
        white-space: nowrap;
      }
      .animate-row1 { animation: row-scroll 30s linear infinite; }
      .animate-row2 { animation: row-scroll 36s linear infinite 2s; }
    `}</style>
  </section>
);

export default LogoSection;